import * as sessionReplay from '@amplitude/session-replay-browser';
import {defineNuxtPlugin} from '#imports';

export default defineNuxtPlugin({
    name: 'tracking-session-replay',
    parallel: true,
    setup() {
        return {
            provide: {
                trackingSessionReplay: sessionReplay,
            },
        };
    },
});
